/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateAttachmentSignDto
 */
export interface CreateUpdateAttachmentSignDto {
    /**
     * 
     * @type {object}
     * @memberof CreateUpdateAttachmentSignDto
     */
    fileContent?: object | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentSignDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentSignDto
     */
    enObjectType: CreateUpdateAttachmentSignDtoEnObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAttachmentSignDto
     */
    objectId: string;
}


/**
 * @export
 */
export const CreateUpdateAttachmentSignDtoEnObjectTypeEnum = {
    Budget: 'Budget',
    Project: 'Project',
    PurchaseInvoice: 'PurchaseInvoice',
    EstimateItemCommentMediaplanner: 'EstimateItemCommentMediaplanner',
    EstimateItemCommentFinance: 'EstimateItemCommentFinance',
    EstimateByMonthMediaplanner: 'EstimateByMonthMediaplanner',
    EstimateByMonthFinance: 'EstimateByMonthFinance',
    Contract: 'Contract',
    SignedContract: 'SignedContract',
    EmployeeSign: 'EmployeeSign',
    SalesInvoice: 'SalesInvoice',
    SentEmail: 'SentEmail'
} as const;
export type CreateUpdateAttachmentSignDtoEnObjectTypeEnum = typeof CreateUpdateAttachmentSignDtoEnObjectTypeEnum[keyof typeof CreateUpdateAttachmentSignDtoEnObjectTypeEnum];


/**
 * Check if a given object implements the CreateUpdateAttachmentSignDto interface.
 */
export function instanceOfCreateUpdateAttachmentSignDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enObjectType" in value;
    isInstance = isInstance && "objectId" in value;

    return isInstance;
}

export function CreateUpdateAttachmentSignDtoFromJSON(json: any): CreateUpdateAttachmentSignDto {
    return CreateUpdateAttachmentSignDtoFromJSONTyped(json, false);
}

export function CreateUpdateAttachmentSignDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateAttachmentSignDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileContent': !exists(json, 'fileContent') ? undefined : json['fileContent'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'enObjectType': json['enObjectType'],
        'objectId': json['objectId'],
    };
}

export function CreateUpdateAttachmentSignDtoToJSON(value?: CreateUpdateAttachmentSignDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileContent': value.fileContent,
        'name': value.name,
        'enObjectType': value.enObjectType,
        'objectId': value.objectId,
    };
}

